<template>
  <div>
    <div class="home_box">
      <div class="to_case">
        <h3>完工案例视频</h3>
        <p @click="$router.push('/VideoList')">更多 ></p>
      </div>
    </div>
    <div class="lateral-sliding">
      <!-- <div
        class="lateral-sliding-item"
        v-for="item in items"
        :key="item.id"
        @click="toCompany(item.id, item.fen)"
      >

    
        <div class="each-img">
          <div class="shop_pic">
            <img :src="item.pic" alt />
          </div>
          <div>
            <h5>{{ item.name }}</h5>
            <span class="star_rank" :class="[item.star]"></span>
            <span>{{ item.pl }} 条评论</span>
          </div>
        </div>
      </div>  -->

      <div class="lateral-sliding-item"
         v-for="item in items"
        :key="item.id"
        @click="toCompany(item.videopath)"

      >
        <img :src="item.cover" alt />
        <div class="bb">
          <p>{{item.title}}</p>
          <div class="bb_">
            <span>{{item.desc}}</span>
            <div></div>
            <span>{{item.num}}m²</span>
          </div>
        </div>
      </div>

  
    </div>
  </div>
</template>

<script>


export default {
  data() {
    return {
      items: [],
      videopath:'',
    };
  },
  computed: {},
  watch: {},
  methods: {
    // async getCom() {
    //   const res = await this.$http.get("/home/api/getcom?flag=1");
    //   // console.log(res.data.data);
    //   // this.case_list.splice(0, this.case_list.length);

    //   var caseItem = "";
    //   // this.case_list.splice(0, this.case_list.length);
    //   for (var i = 0; i < res.data.data.length; i++) {
    //     var fen = res.data.data[i].tu;
    //     // console.log(fen);
    //     caseItem = {
    //       pic: res.data.data[i].logo,
    //       name: res.data.data[i].shopname,
    //       pl: res.data.data[i].ecount,
    //       fen: res.data.data[i].fen,
    //       star: "star_rank_" + fen + "0",
    //       id: res.data.data[i].id,
    //     };
    //     this.items.push(caseItem);
    //   }
    // },
// 视频
      async getVideo() {
      const res = await this.$http.get('/getGong');
    // console.log(res.data);
    this.items=res.data
      // var caseItem = "";
      // this.case_list.splice(0, this.case_list.length);
      // for (var i = 0; i < res.data.data.length; i++) {
    
      //   caseItem = {
      //     pic: res.data.data[i].logo,
      //     name: res.data.data[i].shopname,
      //     pl: res.data.data[i].ecount,
      //     fen: res.data.data[i].fen,
      //     star: "star_rank_" + fen + "0",
      //     id: res.data.data[i].id,
      //   };
      //   this.items.push(caseItem);
      // }
    },



    async toCompany(videopath) {
      this.$router.push({ path: "/Shop", query: { videopath: videopath, } });
      window.location.reload();
    },
  },
  created() {
    this.getVideo();
  },
};
</script>

<style scoped lang="scss">
.home_box {
  background-color: #fff;
  padding: 0 10px 0;
  .to_case {
    display: flex;
    align-items: center;
    justify-content: space-between;
    h3 {
      text-align: center;
      margin: 10px 0;
    }
    p {
      color: #666;
      font-size: 12px;
    }
  }
}
.lateral-sliding {
 display: flex;
  overflow-y: hidden;
  overflow-x: scroll;
  scrollbar-width: none;
  background: #fff;
  margin-bottom: 10px;
}
::-webkit-scrollbar {
  width: 0 !important;
}
.lateral-sliding-item {
  display: flex;
  margin-right: 10px;
  background-color: #fff;
  box-shadow: 0 -1px 5px 5px #f6f6f6;
}
.each-img {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  width: 150px;
  height: 160px;
  padding: 10px 0 5px;
  .shop_pic {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    border: 1px solid #ddd;
    padding: 3px;
    overflow: hidden;
    img {
      width: 100%;
    }
  }
  h5 {
    font-size: 14px;
    text-align: center;
    margin: 0 0 5px;
  }
  span.star_rank {
    display: inline-block;
    width: 70px;
    height: 12px;
    background: url("../../assets/images/comment_star.png") no-repeat;
    background-size: 80px auto;
  }
  span.star_rank_50 {
    background-position: 0 0px;
  }
  span.star_rank_40 {
    background-position: 0 -14px;
  }
  span.star_rank_30 {
    background-position: 0 -29px;
  }
  span.star_rank_20 {
    background-position: 0 -43px;
  }
  span.star_rank_10 {
    background-position: 0 -57px;
  }
  span.star_rank_00 {
    background-position: 0 -71px;
  }
  span {
    font-size: 12px;
    color: #666;
  }
}

.lateral-sliding-item {
  // overflow: hidden;
  width: 50%;
  box-sizing: content-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #fff;
    border-bottom: 1px solid grey;

  img {
    width: 100%;
    width: 150px;
  }
  .bb {
    text-align: center;
    display: flex;
    flex-direction: column;
    // align-items: center;
    padding-bottom: 10px;
    align-items: center;
    p {
      // display: flex;
      // justify-content: center;
      text-align: right;
      margin-top: 3px;
      font-weight: bold;
      // width: 80%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 10px;
      margin-bottom: 3px;
    }
    .bb_ {
      margin-top: 3px;
      display: flex;
      justify-content: center;
      align-items: center;
      // justify-content: space-between;
      span {
        font-size: 10px;
      }
      div {
        margin-left: 3px;
        margin-right: 3px;
        width: 2px;
        height: 10px;
        background-color: #ffe001;
      }
    }
  }
}
</style>
